import styled from 'styled-components';
import { theme } from 'theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 0 190px;
  max-width: 692px;
  max-height: 684px;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: rgba(249, 242, 236, 1);

  @media (max-width: ${theme.breakpoints.sm}) {
    margin: auto;
    padding: 0 8%;
    max-height: 630px;
    gap: 6px;
  }
`

export const FormParent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  & > div {
    @media screen and (max-width: ${theme.breakpoints.sm}) {
      margin-bottom: 5px;
    }
  }
`

export const ForgotPassword = styled.div`
  font-size: 10px;
  color: ${theme.palette.primary};
  margin-top: -10px;
  cursor: pointer;
  text-decoration: underline;
`
